<!-- src/components/projects/Boxes.vue -->
<template>
  <div class="container">
    <div class="row">
      <div class="col-3">
        <ul class="list-group mb-3">
          <li class="list-group-item">
            <label class="form-label" for="caixa-ambient">Ambient</label>
            <select class="form-control" id="caixa-ambient" v-model="ambient">
              <option value="">Selecione o Ambient</option>
              <option
                v-for="ambient in ambients"
                :key="ambient.id"
                :value="ambient.id"
              >
                {{ ambient.name }}
              </option>
            </select>
          </li>
          <li class="list-group-item">
            <label class="form-label" for="caixa-numero">Number</label>
            <input
              type="number"
              class="form-control"
              id="ambient-name"
              placeholder="Name Ambient"
              v-model="number"
            />
          </li>
          <li class="list-group-item">
            <label class="form-label" for="caixa-tipo">Type:</label>
            <select class="form-control" v-model="type">
              <option>Selecione o Type</option>
              <option value="2x2">Caixa 2x2</option>
              <option value="4x2">Caixa 4x2</option>
              <option value="4x4">Caixa 4x4</option>
            </select>
          </li>
          <li class="list-group-item">
            <label class="form-label" for="caixa-plate">Plate:</label>
            <select class="form-control" id="caixa-plate" v-model="plate">
              <option selected>Select Plate</option>
              <option value="4x4-0" data-quantidade="0">4x4 Cega</option>
              <option value="4x4-2" data-quantidade="2">4x4 2 Postos</option>
              <option value="4x4-4" data-quantidade="4">4x4 4 Postos</option>
              <option value="4x4-6" data-quantidade="6">4x4 6 Postos</option>
            </select>
          </li>
        </ul>
      </div>
      <div class="col-9">
        <div class="row justify-content-end mb-2">
          <div class="col-1">
            <button class="btn btn-success" @click="addBoxe">
              <i class="bi bi-plus-circle"></i>
            </button>
          </div>
        </div>
        <div
          class="row mb-2"
          v-for="(moduleRow, rowIndex) in moduleRows"
          :key="rowIndex"
        >
          <div
            class="col-md-4"
            v-for="(modules, index) in moduleRow"
            :key="index"
          >
            <div class="input-group mb-2">
              <span class="input-group-text">{{
                index + 1 + rowIndex * 3
              }}</span>
              <select
                class="form-select"
                v-model="modules.type"
                aria-label="Module select"
              >
                <option selected>Choose...</option>
                <option value="modulo-interruptor-simples">
                  Módulo Interruptor Simples
                </option>
                <option value="modulo-interruptor-paralelo">
                  Módulo Interruptor Paralelo
                </option>
                <option value="modulo-interruptor-intermediario">
                  Módulo Interruptor Intermediário
                </option>
                <option value="modulo-tomada-10-branco">
                  Módulo Tomada 10A Branco
                </option>
                <option value="modulo-tomada-10-vermelho">
                  Módulo Tomada 10A Vermelho
                </option>
                <option value="modulo-tomada-20-branco">
                  Módulo Tomada 20A Branco
                </option>
                <option value="modulo-tomada-20-vermelho">
                  Módulo Tomada 20A Vermelho
                </option>
              </select>
              <input
                type="text"
                class="form-control"
                v-model="module.identification"
                placeholder="Identificação"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <table id="table-caixas" class="table table-bordered table-hover">
              <thead>
                <tr>
                  <th>Number</th>
                  <th>Plate</th>
                  <th>Amount</th>
                  <th>Identification</th>
                  <th style="width: 60px"></th>
                </tr>
              </thead>
              <tbody>
                <template
                  v-for="(boxes, ambient) in groupedBoxes"
                  :key="ambient"
                >
                  <tr>
                    <td :colspan="5">{{ getAmbientName(ambient) }}</td>
                  </tr>
                  <tr v-for="boxe in boxes" :key="boxe.id">
                    <td>{{ boxe.number }}</td>
                    <td>{{ boxe.type }}</td>
                    <td>{{ (boxe.modules || []).length }}</td>
                    <td>
                      [{{
                        (boxe.modules || [])
                          .map((module) => module.identification)
                          .join(", ")
                      }}]
                    </td>
                    <td>
                      <div class="btn-group btn-group-sm">
                        <button
                          v-if="editingId === boxe.id"
                          @click="saveEdit(boxe.id)"
                          class="btn btn-secondary btn-sm"
                        >
                          <i class="fas fa-save"></i>
                        </button>
                        <button
                          v-else
                          @click="editBoxe(boxe)"
                          class="btn btn-secondary btn-sm"
                        >
                          <i class="fas fa-pencil-alt"></i>
                        </button>
                        <button
                          @click="deleteBoxe(boxe.id)"
                          class="btn btn-danger btn-sm"
                        >
                          <i class="far fa-trash-alt"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useProjectStore } from "@/stores/projectStore";
import { ref, onMounted, computed, watch } from "vue";

export default {
  setup() {
    const store = useProjectStore();

    const ambient = ref("");
    const number = ref("");
    const type = ref("");
    const plate = ref("");
    const module = ref([]);
    const modules = ref([]);
    const editingId = ref(null);
    const editingAmbient = ref("");
    const editingPlate = ref("");

    const ambients = computed(() => store.getAllAmbients());
    const boxes = computed(() => store.getAllBoxes());

    // Agrupa boxes por ambiente
    const groupedBoxes = computed(() => {
      return boxes.value.reduce((groups, box) => {
        const ambientName = box.ambient;
        if (!groups[ambientName]) {
          groups[ambientName] = [];
        }
        groups[ambientName].push(box);
        return groups;
      }, {});
    });

    const addBoxe = async () => {
      // Defina os módulos que deseja salvar na caixa
      const modulesArray = modules.value.map((module) => ({
        type: module.type, // tipo do módulo
        identification: module.identification, // identificação do circuito
      }));

      await store.createBoxe({
        ambient: ambient.value,
        number: number.value,
        type: type.value,
        plate: plate.value,
        modules: modulesArray,
      });

      // Limpe os campos após salvar
      ambient.value = "";
      number.value = "";
      type.value = "";
      plate.value = "";
      modules.value = [];
    };

    // Função para confirmar exclusão
    const confirmDeleteBoxe = (boxeId) => {
      if (confirm("Tem certeza que deseja excluir esta caixa?")) {
        store.deleteBoxe(boxeId);
      }
    };

    // Função para buscar o nome do location com base no ID
    const getAmbientName = (ambientId) => {
      const ambient = ambients.value.find((amb) => amb.id === ambientId);
      return ambient ? ambient.name : "Unknown Location";
    };

    // Função de observação para atualizar a quantidade de módulos com base no plate
    watch(plate, (newType) => {
      const selectedOption = document.querySelector(
        `#caixa-plate option[value="${newType}"]`
      );
      const maxModules = selectedOption
        ? parseInt(selectedOption.dataset.quantidade, 10)
        : 0;
      modules.value = Array.from({ length: maxModules }, () => ({}));
    });

    // Computed para dividir os módulos em grupos de até 3 por linha
    const moduleRows = computed(() => {
      const rows = [];
      for (let i = 0; i < modules.value.length; i += 3) {
        rows.push(modules.value.slice(i, i + 3));
      }
      return rows;
    });

    onMounted(() => {
      store.fetchProjects();
    });

    return {
      ambient,
      ambients,
      boxes,
      number,
      type,
      plate,
      module,
      modules,
      moduleRows,
      editingId,
      editingAmbient,
      editingPlate,

      groupedBoxes,
      addBoxe,
      confirmDeleteBoxe,
      getAmbientName,
    };
  },
};
</script>
